// extracted by mini-css-extract-plugin
module.exports = {"tag":"a10a3f92e9--tag--14rPx"};